import { Price } from '@ds'
import { CardInfo, getCDNUrl, useMonetization, usePaymentOrder } from '@shared'

import { Button } from '../Button'
import styles from './HintPaymentPopup.module.scss'
import { HintPaymentOverlayData, useMainQuestActions, useOverlayActions } from '@store'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'


export const HintPaymentPopup = ({
  hint,
}: HintPaymentOverlayData['payload']) => {
  const { hideOverlay } = useOverlayActions()
  const { purchaseHintForXTR } = usePaymentOrder()
  const { fetch } = useMainQuestActions()
  const { showAd, dailyLimit, isLoading } = useMonetization('hint', 'adsgram')
  const { t } = useTranslation();

  const limit = useMemo(() => {
    if (!dailyLimit) return '';
    const left = Math.max(0, dailyLimit.limit - dailyLimit.used);
    return `${left}/${dailyLimit.limit}`;
  }, [dailyLimit]);

  const disabled = useMemo(() => {
    if (!dailyLimit) return false;
    return dailyLimit.used >= dailyLimit.limit;
  }, [dailyLimit]);

  const cardInfo = useMemo(() => {
    return {
      url: getCDNUrl("/assets/hints/popup-logo.png"),
      effects: {},
      title: hint.adUnlockEnabled ? t('hint.showHint') : t('hint.showSolution'),
      description: hint.adUnlockEnabled ? '' : t('hint.showSolutionDescription')
    }
  }, [t])


  return (
    <CardInfo
      url={cardInfo.url}
      title={cardInfo.title}
      description={cardInfo.description}
      effects={cardInfo.effects}
      onClose={hideOverlay}
    >
      <div className={styles.buttons}>
        <Button
          icon="buy"
          onClick={() => {
            hideOverlay()
            purchaseHintForXTR(hint.id, () => fetch())
          }}
        >
          Buy for 
          <Price value={hint.starPrice ?? 0} className={styles.price} />
          | 30% off
        </Button>
        {hint.adUnlockEnabled && <Button
          icon="crypto"
          isLoading={isLoading}
          onClick={() => {
            if (disabled) return;
            showAd(String(hint.id), () => {
              fetch()
              hideOverlay()
            })
          }}
        >
          Watch ad to get a hint
          <div className={styles.limitation}>
          <p>
            {limit}
          </p>
        </div>
        </Button>}
      </div>
    </CardInfo>
  )
}
